import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import ajax from '../utils/ajax'
import functions from '../utils/functions';

class Home extends Component {


    state = {
        screen: "Login",
        loggedIn: true,
        // accessInfo: functions.permissionGuard()
    }

    render() {
        return (


            <body>

                {/* <!-- Preloader Start --> */}
                {/* <div class="preloader">
                    <div class="loading-container">
                        <div class="loading"></div>
                        <div id="loading-icon"><img src="images/loader.svg" alt=""/></div>
                    </div>
                </div> */}
                {/* <!-- Preloader End --> */}

                {/* <!-- Header Start --> */}
                <header class="main-header">
                    <div class="header-sticky">
                        <nav class="navbar navbar-expand-lg">
                            <div class="container">
                                {/* <!-- Logo Start --> */}
                                <a class="navbar-brand" href="">
                                    <img src="assets/images/logo512.png" style={{height: '60px'}} alt="Logo"/>
                                </a>
                                {/* <!-- Logo End --> */}
                                <div class="navbar-toggle"></div>
                            </div>
                        </nav>
                        <div class="responsive-menu"></div>
                    </div>
                </header>
                {/* <!-- Header End --> */}

                {/* <!-- Page Header Start --> */}
                <div class="page-header">
                    {/* <!-- Grid Lines Start --> */}
                    <div class="grid-lines">
                        <div class="grid-line-1"></div>
                        <div class="grid-line-2"></div>
                        <div class="grid-line-3"></div>
                        <div class="grid-line-4"></div>
                        <div class="grid-line-5"></div>
                    </div>
                    {/* <!-- Grid Lines End --> */}
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12">
                                {/* <!-- Page Header Box Start --> */}
                                <div class="page-header-box">
                                    <h1 class="wow fadeInUp" data-cursor="-opaque">PesaRates API Pricing <span style={{WebkitBackgroundClip:'text'}}>Plans</span></h1>

                                </div>
                                {/* <!-- Page Header Box End --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Page Header End --> */}

                {/* <!-- Page Pricing Start --> */}
                <div class="">
                    <div class="">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                {/* <!-- Pricing Box Start --> */}
                                <div class="pricing-item wow fadeInUp">
                                    {/* <!-- Pricing Header Start --> */}
                                    <div class="pricing-header section-title">
                                        <h3>Free plan</h3>
                                        <h2>$0/month</h2>
                                        <p>* Advanced security features designed for efficiency & reliability</p>
                                    </div>
                                    {/* <!-- Pricing Header End --> */}

                                    {/* <!-- Pricing Body Start --> */}
                                    <div class="pricing-body">
                                        <ul>
                                            <li>One request per day</li>
                                            <li>One user account</li>
                                            <li>One month history request</li>
                                            <li>Upto three currencies</li>
                                            <li>Email support</li>
                                        </ul>
                                    </div>
                                    {/* <!-- Pricing Body End --> */}

                                    {/* <!-- Pricing Button Start --> */}
                                    <div class="pricing-btn">
                                        <a href="" class="btn-default">Start</a>
                                    </div>
                                    {/* <!-- Pricing Button End --> */}
                                </div>
                                {/* <!-- Pricing Box End --> */}
                            </div>

                            <div class="col-lg-4 col-md-6">
                                {/* <!-- Pricing Box Start --> */}
                                <div class="pricing-item highlighted-box wow fadeInUp" data-wow-delay="0.2s">
                                    {/* <!-- Pricing Header Start --> */}
                                    <div class="pricing-header section-title">
                                        <h3>Popular Plan</h3>
                                        <h2>$10/month</h2>
                                        <p>* Advanced security features designed for efficiency & reliability</p>
                                    </div>
                                    {/* <!-- Pricing Header End --> */}

                                    {/* <!-- Pricing Body Start --> */}
                                    <div class="pricing-body">
                                        <ul>
                                            <li>Five requests per day</li>
                                            <li>Two user accounts</li>
                                            <li>Three month history request</li>
                                            <li>Upto Ten currencies</li>
                                            <li>24/7 support</li>
                                        </ul>
                                    </div>
                                    {/* <!-- Pricing Body End --> */}

                                    {/* <!-- Pricing Button Start --> */}
                                    <div class="pricing-btn">
                                        <a href="" class="btn-default">Start Plan</a>
                                    </div>
                                    {/* <!-- Pricing Button End --> */}
                                </div>
                                {/* <!-- Pricing Box End --> */}
                            </div>

                            <div class="col-lg-4 col-md-6">
                                {/* <!-- Pricing Box Start --> */}
                                <div class="pricing-item wow fadeInUp" data-wow-delay="0.4s">
                                    {/* <!-- Pricing Header Start --> */}
                                    <div class="pricing-header section-title">
                                        <h3>Pro plan</h3>
                                        <h2>$30/month</h2>
                                        <p>* Advanced security features designed for efficiency & reliability</p>
                                    </div>
                                    {/* <!-- Pricing Header End --> */}

                                    {/* <!-- Pricing Body Start --> */}
                                    <div class="pricing-body">
                                        <ul>
                                            <li>Unlimited Request</li>
                                            <li>Upto five user accounts</li>
                                            <li>All currency history and analysis</li>
                                            <li>All currencies</li>
                                                <li>Dedicated 24/7 support</li>
                                        </ul>
                                    </div>
                                    {/* <!-- Pricing Body End --> */}

                                    {/* <!-- Pricing Button Start --> */}
                                    <div class="pricing-btn">
                                        <a href="" class="btn-default">Start Plan</a>
                                    </div>
                                    {/* <!-- Pricing Button End --> */}
                                </div>
                                {/* <!-- Pricing Box End --> */}
                            </div>

                            <div class="col-lg-12">
                                {/* <!-- Pricing Benifit List Start --> */}
                                <div class="pricing-benefit-list wow fadeInUp" data-wow-delay="0.6s">
                                    <ul>
                                        <li><img src="assets/images/icon-pricing-benefit-1.svg" alt=""/>Free stater plan</li>
                                        <li><img src="assets/images/icon-pricing-benefit-2.svg" alt=""/>No any hidden fees pay</li>
                                        <li><img src="assets/images/icon-pricing-benefit-3.svg" alt=""/>You can cancel anytime </li>
                                    </ul>
                                </div>
                                {/* <!-- Pricing Benifit List End --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Page Pricing End --> */}

                {/* <!-- Our Faqs Section Start --> */}
                <div class="our-faqs">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                {/* <!-- Faqs Content Start --> */}
                                <div class="faqs-content">
                                    {/* <!-- Section Title Start --> */}
                                    <div class="section-title">
                                        <h3 class="wow fadeInUp">Frequently Asked Questions</h3>
                                        <h2 class="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Your complete FAQ guide to<br/> <span style={{WebkitBackgroundClip:'text'}}> Pesa Rates Api</span></h2>
                                    </div>
                                    {/* <!-- Section Title End --> */}

                                    {/* <!-- Faqs Contact Box Start --> */}
                                    <div class="faqs-contact-box">
                                        {/* <!-- Faqs Contact Item Start --> */}
                                        <div class="faqs-contact-item wow fadeInUp" data-wow-delay="0.4s">
                                            <div class="icon-box">
                                                <img src="assets/images/sidebar-cta-img.svg" alt=""/>
                                            </div>
                                            <div class="faqs-contact-item-content">
                                                <h3>24/7 Customer Care</h3>
                                                <p><a href="tel:659888695">(+256) 393 000 417 </a></p>
                                            </div>
                                        </div>
                                        {/* <!-- Faqs Contact Item End --> */}

                                        {/* <!-- Faqs Contact Item Start --> */}
                                        <div class="faqs-contact-item wow fadeInUp" data-wow-delay="0.6s">
                                            <div class="icon-box">
                                                <img src="assets/images/icon-mail.svg" alt=""/>
                                            </div>
                                            <div class="faqs-contact-item-content">
                                                <h3>Technical Issues</h3>
                                                <p><a href="mailto:info@domainname.com">support@pesarates.com</a></p>
                                            </div>
                                        </div>
                                        {/* <!-- Faqs Contact Item End --> */}
                                    </div>
                                    {/* <!-- Faqs Contact Box End --> */}

                                    {/* <!-- Faqs Image Start --> */}
                                    <div class="faqs-image">
                                        <figure class="image-anime">
                                            <img src="assets/images/faqs-image.jpg" alt=""/>
                                        </figure>
                                    </div>
                                    {/* <!-- Faqs Image End --> */}
                                </div>
                                {/* <!-- Faqs Content End --> */}
                            </div>

                            <div class="col-lg-6">
                                {/* <!-- FAQ Accordion Start --> */}
                                <div class="faq-accordion" id="faqaccordion">
                                    {/* <!-- FAQ Item Start --> */}
                                    <div class="accordion-item wow fadeInUp">
                                        <h2 class="accordion-header" id="heading1">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                                Real Working Currency Rates
                                            </button>
                                        </h2>
                                        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
                                            data-bs-parent="#faqaccordion">
                                            <div class="accordion-body">
                                                <p>Trader Reality! We have the current and trader working rates that are in play. Our data is real time and relatable.</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- FAQ Item End --> */}
                                    {/* <!-- FAQ Item Start --> */}
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                        <h2 class="accordion-header" id="heading2">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                                Secure Platform
                                            </button>
                                        </h2>
                                        <div id="collapse2" class="accordion-collapse collapse show" aria-labelledby="heading2"
                                            data-bs-parent="#faqaccordion">
                                            <div class="accordion-body">
                                                <p>Security! We pride in our platform being fool and pro proof. All the data we exchange with our clients is encrypted and secure.
                                                    We dont share your data with anyone but you.</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- FAQ Item End --> */}

                                    {/* <!-- FAQ Item Start --> */}
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                        <h2 class="accordion-header" id="heading3">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                                Trusted Partners
                                            </button>
                                        </h2>
                                        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
                                            data-bs-parent="#faqaccordion">
                                            <div class="accordion-body">
                                                <p>Our partners have been trusted and approved over time, we are sure you will be satisfied with ou! Small businesses are often targeted by cybercriminals because they
                                                    typically have fewer defenses. Investing in cybersecurity helps protect your
                                                    operations, data.</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- FAQ Item End --> */}

                                    {/* <!-- FAQ Item Start --> */}
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                        <h2 class="accordion-header" id="heading4">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                                Uptime
                                            </button>
                                        </h2>
                                        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
                                            data-bs-parent="#faqaccordion">
                                            <div class="accordion-body">
                                                <p>Our team of engineers have made our severs tp spin and never stop and if they did, we have standby fallback servers that are waiting in que so you'll never experience a single downtime</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- FAQ Item End --> */}

                                    {/* <!-- FAQ Item Start --> */}
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.8s">
                                        <h2 class="accordion-header" id="heading5">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                                24/7 Dedicated Support
                                            </button>
                                        </h2>
                                        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
                                            data-bs-parent="#faqaccordion">
                                            <div class="accordion-body">
                                                <p>We have a dedicated team to help you with any issues around the clock over the phone, mail and over video. The team is commited and dedicated to our clients.</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- FAQ Item End --> */}
                                </div>
                                {/* <!-- FAQ Accordion End --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Our Faqs Section End --> */}

                {/* <!-- Footer Start --> */}
                <footer class="">
                    <div class="container">
                        <div class="row">

                            <div class="col-lg-12">
                                <div class="footer-copyright-text">
                                    <p>Copyright © 2025 All Rights Reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </body>



        )
    }
}
export default Home

